import { useEffect, useRef } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import SmoothScroll from "./components/SmoothScroll";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ChatWidget from "./components/ChatWidget";
import CartDrawer from "./components/CartDrawer";
import NewsletterPopup from "./components/NewsletterPopup";
import { AuthProvider } from "./context/AuthContext";
import { CartProvider } from "./context/CartContext";
import { trackPageView } from "./lib/metaPixel";

import Home from "./pages/Home";
import HowItWorks from "./pages/HowItWorks";
import Products from "./pages/Products";
import Apply from "./pages/Apply";
import Contact from "./pages/Contact";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";
import ProductDetail from "./pages/ProductDetail";
import Conditions from "./pages/Conditions";
import Checkout from "./pages/Checkout";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

// Fire a Meta Pixel PageView on every client-side route change. The base
// snippet in index.html already emits the initial PageView, so skip first render.
function MetaPixelRouteTracker() {
  const location = useLocation();
  const firstRender = useRef(true);
  useEffect(() => {
    if (firstRender.current) { firstRender.current = false; return; }
    trackPageView();
  }, [location.pathname, location.search]);
  return null;
}

function PublicLayout({ children }) {
  return (
    <>
      <Navbar />
      <main>{children}</main>
      <Footer />
      <ChatWidget />
      <CartDrawer />
      <NewsletterPopup />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <CartProvider>
          <BrowserRouter>
            <ScrollToTop />
            <MetaPixelRouteTracker />
            <SmoothScroll>
              <Routes>
                <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
                <Route path="/how-it-works" element={<PublicLayout><HowItWorks /></PublicLayout>} />
                <Route path="/products" element={<PublicLayout><Products category="iphone" /></PublicLayout>} />
                <Route path="/ipads" element={<PublicLayout><Products category="ipad" /></PublicLayout>} />
                <Route path="/macbooks" element={<PublicLayout><Products category="macbook" /></PublicLayout>} />
                <Route path="/product/:id" element={<PublicLayout><ProductDetail /></PublicLayout>} />
                <Route path="/conditions" element={<PublicLayout><Conditions /></PublicLayout>} />
                <Route path="/apply" element={<PublicLayout><Apply /></PublicLayout>} />
                <Route path="/contact" element={<PublicLayout><Contact /></PublicLayout>} />
                <Route path="/checkout" element={<PublicLayout><Checkout /></PublicLayout>} />
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin" element={<AdminDashboard />} />
                <Route path="/payment/success" element={<PaymentSuccess />} />
                <Route path="/payment/cancel" element={<PaymentCancel />} />
              </Routes>
            </SmoothScroll>
            <Toaster position="top-center" richColors />
          </BrowserRouter>
        </CartProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
